import React from 'react';

const Footer = () => {
    return (
        <div className="mt-8 text-center text-gray-600 text-sm">
            <p>© 2025 Worm Detection System | Medical AI Analysis Tool</p>
            <p className="mt-1">For research and diagnostic purposes</p>
        </div>
    );
};

export default Footer;